import { useState, useEffect } from "react";
import axios from "axios";
import { devURL } from "../constants/constants";
import { useSearchParams } from "react-router-dom";
import StationTitle from "../components/station/StationTitle";
import StationAllResults from "../components/station/StationAllResults";
import StationProducts from "../components/station/StationProducts";
import StationMainDiagram from "../components/station/StationMainDiagram";
import '../styles/station.css';
import Loading from "../components/global/Loading";

export default function Station() {
    const [searchParams] = useSearchParams();
    const station = searchParams.get("station");
    const [ data, setData ] = useState(null);

    useEffect( () => {
        async function getData() {
            try {
                setData(null)
                const date = new Date();
                const today = `${date.getFullYear()}-${(date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : date.getMonth() + 1}-${date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()}`
                await axios({
                    method: 'get',
                    url: `${devURL}/live-sales?station=${station}&date=${today}`
                }).then(response => setData(response.data))
            } catch(error) {
                console.log(error)
            };
        };
        getData();
    }, [station]);

    return (
        <div className="station-page">
            <StationTitle station={station}/>
            { !data ? <Loading/> : 
                <>
                    <StationAllResults data={data[0]}/>
                    <div className="products-diagram">
                        <StationProducts data={data[0].today.products}/>
                        <StationMainDiagram data={data[0].today.products}/>
                    </div>                    
                </>
            }
        </div>
    )
}